import { Injectable } from '@angular/core';
import { Observable, Observer, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
//import { LoaderService } from 'src/app/modules/loader/loader.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UploadService {
    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        //private loaderService: LoaderService,
    ) {}

    makeFileRequest(url: string, params: any, files: File[]): Observable<any> {
        const formData: FormData = new FormData();
        const currentUser = localStorage.getItem('currentUser');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${currentUser}`
        });
        if (files) files.forEach(file => formData.append('upload', file, file.name));

        this.toFormData(formData, params, "");

        return this.http.post(url, formData, {
            headers,
            responseType: 'json' 
          }).pipe(
            catchError(this.handleError)
          );
    }

      private handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.error(errorMessage);
        return throwError(errorMessage);
      }

    private toFormData(formData:any, data:any, path:any) {
        if (!isObject(data)) {
            return;
        }

        var p;

        for (p in data) {
            // 是否具有指定的屬性名稱
            if (!data.hasOwnProperty(p)) continue;
            var appendFn;
            var propVal = data[p];

            if (isFileList(propVal) || (Array.isArray(propVal) && !isArrayOfObject(propVal))) {
                appendFn = appendArray;
            }
            else if (isArrayOfObject(propVal)) {

                for (var i = 0; i < propVal.length; i++) {
                    this.toFormData(formData, propVal[i], path + p + "[" + i + "].");
                }
                continue;
            }
            else if (isObject(propVal)) {
                this.toFormData(formData, propVal, path + p + ".");
                continue;
            }
            else {
                appendFn = append;

            }
            if (appendFn) {
                appendFn(p, propVal);
            }
        }

        function isFileList(data:any) {
            return isObject(data) && Array.isArray(data) && data.length > 0 && data[0] instanceof File;
        }

        function isArrayOfObject(data:any) {
            var result = false;

            if (Array.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    if (isObject(data[i])) {
                        result = true;
                        break;
                    }
                }
            }
            return result;
        }

        function appendArray(name:any, arrayVal:any[]) {
            var arrayName = name;
            if (!arrayVal) {
                return;
            }
            for (var i = 0; i < arrayVal.length; i++) {
                append(arrayName, arrayVal[i]);
            }
        }

        function append(name:any, value:any) {
            if (value != null) {
                formData.append(path + name, value);
            }
        }

        function isObject(data:any) {
            return typeof data === 'object';
        }
    }
}
